import React from 'react'
import Field from '../../../common/Field'
import Validator from '../../../common/Validator'
import Reflux from 'reflux'
import moment from 'moment'
import 'moment/locale/hu'
import 'react-datepicker/dist/react-datepicker.css'
import i18 from '../../../../i18'
import api from '../../../../source/api'
import BankHelper from '../../../../helpers/bankHelper'
import BankStore from '../../../../store/bankstore'
import BankActions from '../../../../actions/bankactions'
import NotificationSystem from 'react-notification-system'
import {Link} from 'react-router-dom'
import DatePicker from 'react-date-picker'

class Kontir extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            userconfigs: [],
            company: [],
            step: props.step,
            processing: false,
            company_id: props.location.match.params.id,
            fields: {
                //Mainbookkeeping codes, provided by user
                unknown_items_code: {value: '', error: '', role: {required: true}},
                bank_account_number_code: {value: '', error: '', role: {required: true}},
                buyer_supplier_bookkeeping_number_input_1: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_2: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_3: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_4: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_5: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_6: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_7: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_8: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_9: {value: '0', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_input_10: {value: '0', error: '', role: {required: false}},
                bank_exchange: {value: 'HUF', error: '', role: {required: true}},

                //Input files
                bankStatementFile: {value: '', error: '', role: {required: true}},
                partners: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_1: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_2: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_3: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_4: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_5: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_6: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_7: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_8: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_9: {value: '', error: '', role: {required: false}},
                buyer_supplier_bookkeeping_number_file_10: {value: '', error: '', role: {required: false}},
                extra_files: {value: [], error: '', role: {required: false}},
            },
            start_date: new Date(),
            end_date: new Date(),
            dateErrorMessage: '',
        }
        this.store = BankStore
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        moment.locale('hu')
        this._notificationSystem = this.refs.notificationSystem

        api.get('bank/' + this.state.company_id + '/init')
            .then((response) => {
                let config = response.data.userconfigs;
                let fields = this.state.fields;

                fields.unknown_items_code.value = config.unknown_items_code;
                fields.bank_account_number_code.value = config.bank_account_number_code;
                fields.buyer_supplier_bookkeeping_number_input_1.value = config.buyer_supplier_bookkeeping_number_input_1 || 0;
                fields.buyer_supplier_bookkeeping_number_input_2.value = config.buyer_supplier_bookkeeping_number_input_2 || 0;
                fields.buyer_supplier_bookkeeping_number_input_3.value = config.buyer_supplier_bookkeeping_number_input_3 || 0;
                fields.buyer_supplier_bookkeeping_number_input_4.value = config.buyer_supplier_bookkeeping_number_input_4 || 0;
                fields.buyer_supplier_bookkeeping_number_input_5.value = config.buyer_supplier_bookkeeping_number_input_5 || 0;
                fields.buyer_supplier_bookkeeping_number_input_6.value = config.buyer_supplier_bookkeeping_number_input_6 || 0;
                fields.buyer_supplier_bookkeeping_number_input_7.value = config.buyer_supplier_bookkeeping_number_input_7 || 0;
                fields.buyer_supplier_bookkeeping_number_input_8.value = config.buyer_supplier_bookkeeping_number_input_8 || 0;
                fields.buyer_supplier_bookkeeping_number_input_9.value = config.buyer_supplier_bookkeeping_number_input_9 || 0;
                fields.buyer_supplier_bookkeeping_number_input_10.value = config.buyer_supplier_bookkeeping_number_input_10 || 0;
                fields.bank_exchange.value = config.bank_exchange || 'HUF';

                this.setState({
                    start_date: typeof config.start_date !== 'undefined' && config.start_date !== null ? new Date(config.start_date) : new Date(),
                    end_date: typeof config.end_date !== 'undefined' && config.end_date !== null ? new Date(config.end_date) : new Date(),
                    fields: fields,
                    userconfigs: response.data.userconfigs,
                    company: response.data.company,
                });
            })
    }

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    }

    getBookKeepingNumbers = () => {
        let fields = this.state.fields
        let bookKeepingNumbers = []

        for (let i = 1; i <= 10; ++i) {
            if (fields['buyer_supplier_bookkeeping_number_input_' + i].value > 0) {
                bookKeepingNumbers.push(fields['buyer_supplier_bookkeeping_number_input_' + i].value)
            }
        }

        return bookKeepingNumbers;
    };

    validate = () => {
        let bookKeepingNumbers = this.getBookKeepingNumbers();

        let validator = Validator.validate(this.state.fields)
        let dateError = this.state.start_date > this.state.end_date;
        let bookKeepingNumberError = BankHelper.arrayHasDuplicates(bookKeepingNumbers);
        let error = validator.error || dateError || bookKeepingNumberError;

        if (bookKeepingNumberError) {
            this._addNotification('Egy vagy több főkönyvi szám ismétlődik.', 'error')
        }

        this.setState({
            fields: validator.fields,
            dateErrorMessage: dateError ? 'Kezdő dátum nem lehet nagyobb mint a zárás dátum' : ''
        })
        return !error;
    }

    nextStep = () => {
        if (!this.validate()) {
            return;
        }
        this.setState({
            step: this.state.step + 1,
            processing: true
        });

        const form = this.collectFormData();
        api.postFile('bank/' + this.state.company_id  + '/upload', form)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({processing: false});
                    this.setGlobalState(response.data);
                }
            })
            .catch((err) => {
                this.setState({processing: false});

                if (err.response) {
                    if (err.response.data.message) {
                        this._addNotification(err.response.data.message, 'error');
                    } else {
                        this._addNotification(err.response.data.error.message, 'error');
                    }
                }
            })
    };

    collectFormData = () => {
        let form = new FormData()
        let bankStatementFile = document.querySelector('#bankStatementFile')

        let buyerSupplierFile1 = document.querySelector('#buyer_supplier_bookkeeping_number_file_1')
        let buyerSupplierFile2 = document.querySelector('#buyer_supplier_bookkeeping_number_file_2')
        let buyerSupplierFile3 = document.querySelector('#buyer_supplier_bookkeeping_number_file_3')
        let buyerSupplierFile4 = document.querySelector('#buyer_supplier_bookkeeping_number_file_4')
        let buyerSupplierFile5 = document.querySelector('#buyer_supplier_bookkeeping_number_file_5')
        let buyerSupplierFile6 = document.querySelector('#buyer_supplier_bookkeeping_number_file_6')
        let buyerSupplierFile7 = document.querySelector('#buyer_supplier_bookkeeping_number_file_7')
        let buyerSupplierFile8 = document.querySelector('#buyer_supplier_bookkeeping_number_file_8')
        let buyerSupplierFile9 = document.querySelector('#buyer_supplier_bookkeeping_number_file_9')
        let buyerSupplierFile10 = document.querySelector('#buyer_supplier_bookkeeping_number_file_10')

        let partners = document.querySelector('#partners')

        form.append('buyerSupplierFile1', buyerSupplierFile1.files[0])
        form.append('buyerSupplierFile2', buyerSupplierFile2.files[0])
        form.append('buyerSupplierFile3', buyerSupplierFile3.files[0])
        form.append('buyerSupplierFile4', buyerSupplierFile4.files[0])
        form.append('buyerSupplierFile5', buyerSupplierFile5.files[0])
        form.append('buyerSupplierFile6', buyerSupplierFile6.files[0])
        form.append('buyerSupplierFile7', buyerSupplierFile7.files[0])
        form.append('buyerSupplierFile8', buyerSupplierFile8.files[0])
        form.append('buyerSupplierFile9', buyerSupplierFile9.files[0])
        form.append('buyerSupplierFile10', buyerSupplierFile10.files[0])
        form.append('bankStatementFile', bankStatementFile.files[0])
        form.append('partners', partners.files[0])

        form.append('start_date', moment(this.state.start_date).format('YYYY-MM-DD'))
        form.append('end_date', moment(this.state.end_date).format('YYYY-MM-DD'))
        form.append('company_id', this.state.company_id)
        form.append('unknown_items_code', this.state.fields.unknown_items_code.value)
        form.append('bank_account_number_code', this.state.fields.bank_account_number_code.value)
        form.append('buyer_supplier_bookkeeping_number_input_1', this.state.fields.buyer_supplier_bookkeeping_number_input_1.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_2', this.state.fields.buyer_supplier_bookkeeping_number_input_2.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_3', this.state.fields.buyer_supplier_bookkeeping_number_input_3.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_4', this.state.fields.buyer_supplier_bookkeeping_number_input_4.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_5', this.state.fields.buyer_supplier_bookkeeping_number_input_5.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_6', this.state.fields.buyer_supplier_bookkeeping_number_input_6.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_7', this.state.fields.buyer_supplier_bookkeeping_number_input_7.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_8', this.state.fields.buyer_supplier_bookkeeping_number_input_8.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_9', this.state.fields.buyer_supplier_bookkeeping_number_input_9.value || 0)
        form.append('buyer_supplier_bookkeeping_number_input_10', this.state.fields.buyer_supplier_bookkeeping_number_input_10.value || 0)
        form.append('bank_exchange', this.state.fields.bank_exchange.value);

        for (let i = 0; i < this.state.fields.extra_files.value.length; i++) {
            form.append(`extra_files[${i}]`, this.state.fields.extra_files.value[i])
        }

        return form
    }

    setGlobalState = response => {
        let data = {
            date: {
                start: this.state.start_date,
                end: this.state.end_date
            },
            fields: this.state.fields,
            vszcompanies: response.vszcompanies,
            unprocessed: response.unprocessed,
            processed: response.processed,
            buyerSupplierFile1: response.files['SUPLIER-BUYER-FILE-1'] ? response.files['SUPLIER-BUYER-FILE-1'] : '',
            buyerSupplierFile2: response.files['SUPLIER-BUYER-FILE-2'] ? response.files['SUPLIER-BUYER-FILE-2'] : '',
            buyerSupplierFile3: response.files['SUPLIER-BUYER-FILE-3'] ? response.files['SUPLIER-BUYER-FILE-3'] : '',
            buyerSupplierFile4: response.files['SUPLIER-BUYER-FILE-4'] ? response.files['SUPLIER-BUYER-FILE-4'] : '',
            buyerSupplierFile5: response.files['SUPLIER-BUYER-FILE-5'] ? response.files['SUPLIER-BUYER-FILE-5'] : '',
            buyerSupplierFile6: response.files['SUPLIER-BUYER-FILE-6'] ? response.files['SUPLIER-BUYER-FILE-6'] : '',
            buyerSupplierFile7: response.files['SUPLIER-BUYER-FILE-7'] ? response.files['SUPLIER-BUYER-FILE-7'] : '',
            buyerSupplierFile8: response.files['SUPLIER-BUYER-FILE-8'] ? response.files['SUPLIER-BUYER-FILE-8'] : '',
            buyerSupplierFile9: response.files['SUPLIER-BUYER-FILE-9'] ? response.files['SUPLIER-BUYER-FILE-9'] : '',
            buyerSupplierFile10: response.files['SUPLIER-BUYER-FILE-10'] ? response.files['SUPLIER-BUYER-FILE-10'] : '',
            bankStatementFile: response.files.bankStatementFileUploadedFileName,
            partners: response.files.partners,
            company: this.state.company,
        }

        if (response.unprocessed !== null && !Object.keys(response.unprocessed).length
            && response.processed !== null && !Object.keys(response.processed).length) {
            BankActions.setFlag(false, 'bank')
            this._addNotification('Kérjük ellerőrizze a következő adatokat:  Bemenit fájlok és kiválasztott könyvelési időszak.', 'error')
            return
        }

        BankHelper.resetLocalStorage()

        this.props.setBankState({
            dataVszItems: response.vszdata
        });

        BankHelper.setStatements(response.statement)
        BankActions.setData(data);
        BankHelper.setFileNames(response.files)

        this.props.setNextStep()
    }

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    };

    onDateChange = (field, date) => {
        this.setState({[field]: date})
    };

    render() {
        return (
            <div className='col-12'>
                <h4 className='text-left'>Kiválasztott cég: {typeof this.state.company !== 'undefined' ? this.state.company.name : ''} (<Link className='link-color' to='/'>cég csere</Link>)</h4>
                <br/>
                <div className='row'>
                    <div className='col-md-3'>
                        <p>{i18.BANK._bookingIntervall}</p>
                    </div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            name="start_date"
                            value={this.state.start_date}
                            onChange={(date) => this.onDateChange('start_date', date)}
                            required={true}
                            showLeadingZeros={true}
                        />
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-3'>
                        <DatePicker
                            className="date-picker"
                            name="end_date"
                            value={this.state.end_date}
                            onChange={(date) => this.onDateChange('end_date', date)}
                            required={true}
                            showLeadingZeros={true}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 offset-md-3'>
                        <p className={this.state.dateErrorMessage ? 'help-block help-block-error' : 'd-none'}><span className='error'><i className='fa fa-warning'></i> {this.state.dateErrorMessage}</span></p>
                    </div>
                </div>
                <table className='table table-striped table-aibook-bordered'>
                    <tbody>
                    <tr>
                        <td>{i18.BANK._unknowItems}</td>
                        <td>
                            <Field
                                type='text'
                                id='unknown_items_code'
                                name='unknown_items_code'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>{i18.BANK._bankLedgerNumber}</td>
                        <td>
                            <Field
                                type='text'
                                id='bank_account_number_code'
                                name='bank_account_number_code'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 1. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_1'
                                name='buyer_supplier_bookkeeping_number_input_1'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 2. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_2'
                                name='buyer_supplier_bookkeeping_number_input_2'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 3. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_3'
                                name='buyer_supplier_bookkeeping_number_input_3'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 4. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_4'
                                name='buyer_supplier_bookkeeping_number_input_4'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 5. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_5'
                                name='buyer_supplier_bookkeeping_number_input_5'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 6. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_6'
                                name='buyer_supplier_bookkeeping_number_input_6'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 7. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_7'
                                name='buyer_supplier_bookkeeping_number_input_7'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 8. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_8'
                                name='buyer_supplier_bookkeeping_number_input_8'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 9. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_9'
                                name='buyer_supplier_bookkeeping_number_input_9'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Add meg a vevő/szállító 10. főkönyvi számot</td>
                        <td>
                            <Field
                                type='text'
                                id='buyer_supplier_bookkeeping_number_input_10'
                                name='buyer_supplier_bookkeeping_number_input_10'
                                label=''
                                classLabel='control-label'
                                classInput='bordered-input'
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Bank devizaneme</td>
                        <td>
                            <select
                                id='bank_exchange'
                                className='form-control bordered-input'
                                name='bank_exchange'
                                value={this.state.fields.bank_exchange.value}
                                style={{width: '150px', height: '28px'}}
                                onChange={(event) => this.onElementChange(event)}
                            >
                                <option value="HUF">HUF</option>
                                <option value="EUR">EUR</option>
                                <option value="USD">USD</option>
                            </select>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div className='row'>
                    <div className='col-4'>
                        <Field
                            type='file'
                            id='bankStatementFile'
                            name='bankStatementFile'
                            label={i18.BANK._bankStatement}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='col-4'>
                        <Field
                            type='file'
                            id='partners'
                            name='partners'
                            label={i18.BANK._partnermaster}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='col-4'>
                        <Field
                            type='file'
                            id='extra_files'
                            name='extra_files'
                            label='Gyűjtő számlák (GLS, MPL, SimplePay)'
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                            multiple={true}
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12 hr-separator'></div>
                </div>

                <div className='row'>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_1'
                            name='buyer_supplier_bookkeeping_number_file_1'
                            label={'1. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_1.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_2'
                            name='buyer_supplier_bookkeeping_number_file_2'
                            label={'2. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_2.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_3'
                            name='buyer_supplier_bookkeeping_number_file_3'
                            label={'3. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_3.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_4'
                            name='buyer_supplier_bookkeeping_number_file_4'
                            label={'4. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_4.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_5'
                            name='buyer_supplier_bookkeeping_number_file_5'
                            label={'5. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_5.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_6'
                            name='buyer_supplier_bookkeeping_number_file_6'
                            label={'6. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_6.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_7'
                            name='buyer_supplier_bookkeeping_number_file_7'
                            label={'7. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_7.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_8'
                            name='buyer_supplier_bookkeeping_number_file_8'
                            label={'8. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_8.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_9'
                            name='buyer_supplier_bookkeeping_number_file_9'
                            label={'9. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_9.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div className='text-left width-20percent'>
                        <Field
                            type='file'
                            id='buyer_supplier_bookkeeping_number_file_10'
                            name='buyer_supplier_bookkeeping_number_file_10'
                            label={'10. v/sz tábla: (' + (this.state.fields.buyer_supplier_bookkeeping_number_input_10.value || 0) + ')'}
                            fileUploadEndpoint=''
                            classLabel='control-label'
                            classInput='file-input'
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <br/>
                        <div className='next-step-btn-container'>
                            <a onClick={() => this.nextStep()} className={this.state.processing ? 'disabled next-step' : 'next-step'}>{this.state.processing ? i18.BUTTONS._processing : i18.BUTTONS._goToAccountAssignment}</a>
                        </div>
                    </div>
                </div>

                <NotificationSystem ref='notificationSystem'/>
            </div>
        )
    }
}

export default Kontir


// WEBPACK FOOTER //
// ./src/components/bank/steps/upload/Kontir.js